// Lib
import React from 'react';

// Hooks
import useUser from '../../../hooks/useUser';

// Constants
import { DOWNLOAD_ONLY_LABEL } from '../../../constants/products';

// Styles
import { useStyles } from './CountDescriptionStyles';

const StockItem = ({
  availableQuantity,
  view,
  unavailableLabel = '',
  className,
  isDigitalAsset = false,
}) => {
  const { isKiteUser } = useUser();
  const { classes, cx } = useStyles({ isKiteUser, unavailableLabel, view });

  const renderStock = () => {
    if (isDigitalAsset) {
      return DOWNLOAD_ONLY_LABEL;
    }
    if (unavailableLabel) {
      return unavailableLabel;
    }
    return (
      <>
        In Stock: <span>{availableQuantity}</span>
      </>
    );
  };

  return (
    <div className={cx(className, classes.stockItem)}>{renderStock()}</div>
  );
};

const CountDescription = ({
  perUnitQty,
  maxAllowedQty,
  availableQuantity,
  view,
  unavailableLabel,
  isDigitalAsset = false,
}) => {
  const { isKiteUser } = useUser();
  const { classes } = useStyles({ view, isKiteUser });

  return (
    <div className={classes.countDescription}>
      {perUnitQty && (
        <div>
          Per Unit Qty:
          <span className={classes.countDescriptionValue}> {perUnitQty}</span>
        </div>
      )}
      {maxAllowedQty !== null && (
        <div>
          Max. Allowed Qty:
          <span className={classes.countDescriptionValue}>
            {' '}
            {maxAllowedQty}
          </span>
        </div>
      )}
      <StockItem
        availableQuantity={availableQuantity}
        unavailableLabel={unavailableLabel}
        isDigitalAsset={isDigitalAsset}
      />
    </div>
  );
};

export default CountDescription;

export { StockItem };
